export default {"src":"/_next/static/media/Icon-TravelAuthorization.73c7b9bc.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};